export default "__VITE_ASSET__DHeZrCLT__"